/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceUpdate
 */
export interface DeviceUpdate {
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    idDevice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    idClient?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    syslogHost?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceUpdate
     */
    syslogPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    syslogFacility?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    provisioning?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceUpdate
     */
    keepaliveTimer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    mqttHost?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceUpdate
     */
    mqttPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    mqttUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    mqttPass?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    conf47Type?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DeviceUpdate
     */
    dateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    deviceType?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceUpdate
     */
    mqttVoiceDsts?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceUpdate
     */
    jsonAdditionalConfig?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUpdate
     */
    phone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceUpdate
     */
    needsRefresh?: boolean | null;
}

/**
 * Check if a given object implements the DeviceUpdate interface.
 */
export function instanceOfDeviceUpdate(value: object): value is DeviceUpdate {
    return true;
}

export function DeviceUpdateFromJSON(json: any): DeviceUpdate {
    return DeviceUpdateFromJSONTyped(json, false);
}

export function DeviceUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'idDevice': json['idDevice'] == null ? undefined : json['idDevice'],
        'idClient': json['idClient'] == null ? undefined : json['idClient'],
        'syslogHost': json['syslog_host'] == null ? undefined : json['syslog_host'],
        'syslogPort': json['syslog_port'] == null ? undefined : json['syslog_port'],
        'syslogFacility': json['syslog_facility'] == null ? undefined : json['syslog_facility'],
        'provisioning': json['provisioning'] == null ? undefined : json['provisioning'],
        'keepaliveTimer': json['keepalive_timer'] == null ? undefined : json['keepalive_timer'],
        'password': json['password'] == null ? undefined : json['password'],
        'mqttHost': json['mqtt_host'] == null ? undefined : json['mqtt_host'],
        'mqttPort': json['mqtt_port'] == null ? undefined : json['mqtt_port'],
        'mqttUser': json['mqtt_user'] == null ? undefined : json['mqtt_user'],
        'mqttPass': json['mqtt_pass'] == null ? undefined : json['mqtt_pass'],
        'conf47Type': json['conf47Type'] == null ? undefined : json['conf47Type'],
        'dateTime': json['date_time'] == null ? undefined : (new Date(json['date_time'])),
        'deviceType': json['deviceType'] == null ? undefined : json['deviceType'],
        'mqttVoiceDsts': json['mqtt_voice_dsts'] == null ? undefined : json['mqtt_voice_dsts'],
        'jsonAdditionalConfig': json['jsonAdditionalConfig'] == null ? undefined : json['jsonAdditionalConfig'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'needsRefresh': json['needsRefresh'] == null ? undefined : json['needsRefresh'],
    };
}

export function DeviceUpdateToJSON(json: any): DeviceUpdate {
    return DeviceUpdateToJSONTyped(json, false);
}

export function DeviceUpdateToJSONTyped(value?: DeviceUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idDevice': value['idDevice'],
        'idClient': value['idClient'],
        'syslog_host': value['syslogHost'],
        'syslog_port': value['syslogPort'],
        'syslog_facility': value['syslogFacility'],
        'provisioning': value['provisioning'],
        'keepalive_timer': value['keepaliveTimer'],
        'password': value['password'],
        'mqtt_host': value['mqttHost'],
        'mqtt_port': value['mqttPort'],
        'mqtt_user': value['mqttUser'],
        'mqtt_pass': value['mqttPass'],
        'conf47Type': value['conf47Type'],
        'date_time': value['dateTime'] === null ? null : (typeof value['dateTime'] === 'string' ? value['dateTime'] : (value['dateTime'] as any)?.toISOString()),
        'deviceType': value['deviceType'],
        'mqtt_voice_dsts': value['mqttVoiceDsts'],
        'jsonAdditionalConfig': value['jsonAdditionalConfig'],
        'phone': value['phone'],
        'needsRefresh': value['needsRefresh'],
    };
}

